import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Projects',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'projects',
                },
              },
              subqueries: {
                projects: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '``': {
                                          '@$': 'orgEntityId',
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '!=': [
                              {
                                '@': 'piIds',
                              },
                              null,
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  period: {
                    '``': {
                      '@$': 'focusedRange',
                    },
                  },
                  target: 'ent:!projects:!proj',
                  subqueries: {
                    piIds: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!pi',
                      },
                      using: 'projectPiAssignments',
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              {
                                '@.': '!id',
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!personnel:!employee',
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      target: 'ent:!proj_pis:!entry',
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                and: [
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': [
                              '!org',
                              {
                                ref: {
                                  entity: {
                                    '``': {
                                      '@$': 'orgEntityId',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'piRecordId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '!=': [
                          {
                            '@': 'piIds',
                          },
                          null,
                        ],
                      },
                    ],
                  },
                ],
              },
              period: {
                '``': {
                  '@$': 'focusedRange',
                },
              },
              target: 'ent:!projects:!proj',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      id: {
                        '{}': {
                          value: {
                            '@.': '!id',
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      sponsor: {
                        '{}': {
                          value: {
                            '@': 'sponsor',
                          },
                        },
                      },
                      tdcExpense: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'glExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'tdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      idcrExpense: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'glExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'idcrAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      mtdcExpense: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'glExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      effectiveRecovery: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'glExpenses',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'mtdcAmount',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                    0,
                                  ],
                                },
                                0,
                              ],
                              {
                                '/': [
                                  {
                                    '??': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'glExpenses',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'idcrAmount',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    '??': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'glExpenses',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'mtdcAmount',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                piIds: {
                  ref: {
                    attr: 'attr:ent#!proj_pis#!entry:!pi',
                  },
                  using: 'projectPiAssignments',
                  filter: {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'piRecordId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'piRecordId',
                            },
                          },
                          {
                            '@.': '!id',
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!personnel:!employee',
                  selection: {
                    '@.': '!id',
                  },
                },
                sponsor: {
                  ref: {
                    attr: 'attr:ent#!projects#!proj:!sponsor',
                  },
                  target: 'ent:!sponsors:!sponsor',
                  selection: {
                    '@.': '!name',
                  },
                },
                glExpenses: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '{}': {
                      tdcAmount: {
                        if: [
                          [
                            {
                              not: {
                                '=': [
                                  {
                                    '@': 'costType',
                                  },
                                  'IDC',
                                ],
                              },
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                      idcrAmount: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '@': 'costType',
                                },
                                'IDC',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                      mtdcAmount: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '@': 'costType',
                                },
                                'MTDC',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    costType: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!cost_type',
                      },
                    },
                  },
                },
                piDepartments: {
                  ref: {
                    attr: 'attr:ent#!proj_pis#!entry:!pi',
                  },
                  using: 'projectPiAssignments',
                  target: 'ent:!personnel:!employee',
                  selection: {
                    '@.': [
                      '!org',
                      {
                        ref: {
                          entity: '!dept',
                        },
                      },
                    ],
                  },
                },
                projectPiAssignments: {
                  ref: {
                    attr: 'attr:ent#!proj_pis#!entry:!proj',
                  },
                  target: 'ent:!proj_pis:!entry',
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  direct: {
                    '{}': {
                      name: 'Code',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  direct: {
                    '{}': {
                      name: 'Name',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'sponsor',
                  direct: {
                    '{}': {
                      name: 'Sponsor',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'tdcExpense',
                  direct: {
                    '{}': {
                      name: 'TDC',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'mtdcExpense',
                  direct: {
                    '{}': {
                      name: 'MTDC',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'idcrExpense',
                  direct: {
                    '{}': {
                      name: 'IDC-R',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'effectiveRecovery',
                  direct: {
                    '{}': {
                      name: 'Effective Recovery',
                      type: 'PERCENT',
                    },
                  },
                },
              },
            ],
          },
          totalRow: {
            '`': {
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      code: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      name: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      sponsor: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      tdcExpense: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdcExpense',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      idcrExpense: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'idcrExpense',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      mtdcExpense: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdcExpense',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      effectiveRecovery: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'records',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'idcrExpense',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'records',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdcExpense',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                              0,
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                records: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '``': {
                                          '@$': 'orgEntityId',
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '!=': [
                              {
                                '@': 'piIds',
                              },
                              null,
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  period: {
                    '``': {
                      '@$': 'focusedRange',
                    },
                  },
                  target: 'ent:!projects:!proj',
                  selection: {
                    '{}': {
                      tdcExpense: {
                        '??': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'glExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdcAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          0,
                        ],
                      },
                      idcrExpense: {
                        '??': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'glExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'idcrAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          0,
                        ],
                      },
                      mtdcExpense: {
                        '??': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'glExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdcAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    piIds: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!pi',
                      },
                      using: 'projectPiAssignments',
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              {
                                '@.': '!id',
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!personnel:!employee',
                      selection: {
                        '@.': '!id',
                      },
                    },
                    glExpenses: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '{}': {
                          tdcAmount: {
                            if: [
                              [
                                {
                                  not: {
                                    '=': [
                                      {
                                        '@': 'costType',
                                      },
                                      'IDC',
                                    ],
                                  },
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          idcrAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'IDC',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          mtdcAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'MTDC',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        costType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!cost_type',
                          },
                        },
                      },
                    },
                    piDepartments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!pi',
                      },
                      using: 'projectPiAssignments',
                      target: 'ent:!personnel:!employee',
                      selection: {
                        '@.': [
                          '!org',
                          {
                            ref: {
                              entity: '!dept',
                            },
                          },
                        ],
                      },
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      target: 'ent:!proj_pis:!entry',
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2023',
        },
        start: {
          $date: '1/1/2023',
        },
      },
    },
  },
}
